"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const enums_1 = require("../../@shared-types/tenant/enums");
const api_1 = require("../services/api");
let TransactionModel = class TransactionModel {
    constructor(api) {
        this.api = api;
        this.getBillable = () => this
            .api.get('/api/settings/billable-transactions');
        this.translateType = (type) => {
            switch (type) {
                case enums_1.EFeatures.API_DAT_VIN: return 'DAT VIN-Abfragen';
                case enums_1.EFeatures.VEHICLE_SALE: return 'Verkaufte Fahrzeuge';
                case enums_1.EFeatures.API_US_VIN: return 'US VIN-Abfragen';
                default: return 'n/a';
            }
        };
    }
};
TransactionModel = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [typeof (_a = typeof api_1.ApiService !== "undefined" && api_1.ApiService) === "function" ? _a : Object])
], TransactionModel);
exports.default = TransactionModel;
